import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, map, retry, timer } from 'rxjs';
import { api, part } from '../shared/communication-objects/api-path';
import { DSRESTClient } from '../shared/communication-objects/restclient.service';
import { GeneralUtilities } from '../utilities/generaleUtilities';

/**
 * The app's only TranslateLoader: one culture's whole catalog, already merged over en-US, from
 * `Strings/{culture}` (docs/string-resources-redesign.md §4.5).
 *
 * There is no list of groups to keep up to date. The server serves every string, and revalidates
 * with an ETag, so an unchanged catalog costs a 304.
 */
@Injectable({ providedIn: 'root' })
export class CatalogTranslateLoader implements TranslateLoader {
  constructor(private restClient: DSRESTClient) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    return this.restClient.getAsModel<Record<string, string>>(api`Strings/${part(lang)}`).pipe(
      retry({ count: 2, delay: (_err, retryCount) => timer(retryCount * 500) }),
      // ExtendedTranslateService uppercases every key it looks up, so the keys are stored that way.
      map((strings) => GeneralUtilities.toUpperCase(strings) as Record<string, string>),
    );
  }
}
